// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.department-detail-sidebar__receiving-hours-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-bottom: 25px;
  }
  .department-detail-sidebar__receiving-hours-content {
    display: flex;
  }
  .department-detail-sidebar__receiving-hours-switch {
    display: flex;
    align-items: center;
    color: #101010;
    font-weight: 400;
    margin-top: 5px;
  }
  .department-detail-sidebar__receiving-hours-switch > span {
      margin-left: 5px;
    }
  .department-detail-sidebar__receiving-hours-sub-header {
    width: 100%;
    display: flex;
    height: 32px;
    padding-left: 60px;
  }
  .department-detail-sidebar__receiving-hours-sub-header-title {
      font-size: 12px;
      font-weight: 500;
      color: #737980;
      margin-top: auto;
      margin-bottom: auto;
      text-align: center;
      width: 80px;
      margin-left: 22px;
    }
  .department-detail-sidebar__receiving-hours-sub-header-title:nth-child(1) {
        margin-left: 0;
      }
  .department-detail-sidebar__receiving-hours-sub-header-wrapper {
      display: flex;
      padding-right: 45px;
    }
  .department-detail-sidebar__receiving-hours-header {
    font-size: 12px;
    font-weight: 600;
    color: #737980;
    height: 32px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }
  .department-detail-sidebar__receiving-hours-header-right {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-grow: 1;
    }
  .department-detail-sidebar__receiving-hours-section-sub-title {
    color: #737980;
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 0;
    width: 100%;
  }
  .department-detail-sidebar__receiving-hours-section-sub-title-timezone {
      margin-top: 0;
      font-style: italic;
    }
  .department-detail-sidebar__receiving-hours-title {
    margin-top: auto;
    margin-bottom: auto;
    text-transform: capitalize;
    width: 100px;
  }
  .department-detail-sidebar__receiving-hours-open-icon {
    height: 15px;
    margin-top: auto;
    margin-bottom: auto;
    padding-left: 5px;
  }
  .department-detail-sidebar__receiving-hours-preview {
    cursor: pointer;
    display: flex;
    background-color: #f7f8f9;
    border-top: 1px solid #e3e4e6;
    border-bottom: 1px solid #e3e4e6;
    justify-content: flex-start;
    padding-left: 25px;
    padding-top: 12px;
    padding-bottom: 12px;
    color: #333;
  }
  .department-detail-sidebar__receiving-hours-preview > h3 {
      font-weight: 600;
      margin-top: auto;
      margin-bottom: auto;
    }
  .department-detail-sidebar__receiving-hours-bottom-spacing {
    margin-bottom: 5px;
  }
  .department-detail-sidebar__receiving-hours-day-windows {
    width: 50%;
  }
`, "",{"version":3,"sources":["webpack://./app/components/DepartmentDetailSidebar/components/DepartmentDetailSidebarDeliveryPreferences/components/ReceivingHours/style.css"],"names":[],"mappings":"AACE;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,oBAAoB;EACtB;EAEA;IACE,aAAa;EACf;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,eAAe;EAKjB;EAHE;MACE,gBAAgB;IAClB;EAGF;IACE,WAAW;IACX,aAAa;IACb,YAAY;IACZ,kBAAkB;EAqBpB;EAnBE;MACE,eAAe;MACf,gBAAgB;MAChB,cAAc;MACd,gBAAgB;MAChB,mBAAmB;MACnB,kBAAkB;MAClB,WAAW;MACX,iBAAiB;IAKnB;EAHE;QACE,cAAc;MAChB;EAGF;MACE,aAAa;MACb,mBAAmB;IACrB;EAGF;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;EAQb;EANE;MACE,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,YAAY;IACd;EAGF;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;EAMb;EAJE;MACE,aAAa;MACb,kBAAkB;IACpB;EAGF;IACE,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;IAC1B,YAAY;EACd;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;EACnB;EAEA;IACE,eAAe;IACf,aAAa;IACb,yBAAyB;IACzB,6BAA6B;IAC7B,gCAAgC;IAChC,2BAA2B;IAC3B,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,WAAW;EAOb;EALE;MACE,gBAAgB;MAChB,gBAAgB;MAChB,mBAAmB;IACrB;EAGF;IACE,kBAAkB;EACpB;EAEA;IACE,UAAU;EACZ","sourcesContent":[".department-detail-sidebar__receiving-hours {\n  &-wrapper {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    padding-bottom: 25px;\n  }\n\n  &-content {\n    display: flex;\n  }\n\n  &-switch {\n    display: flex;\n    align-items: center;\n    color: #101010;\n    font-weight: 400;\n    margin-top: 5px;\n\n    & > span {\n      margin-left: 5px;\n    }\n  }\n\n  &-sub-header {\n    width: 100%;\n    display: flex;\n    height: 32px;\n    padding-left: 60px;\n\n    &-title {\n      font-size: 12px;\n      font-weight: 500;\n      color: #737980;\n      margin-top: auto;\n      margin-bottom: auto;\n      text-align: center;\n      width: 80px;\n      margin-left: 22px;\n\n      &:nth-child(1) {\n        margin-left: 0;\n      }\n    }\n\n    &-wrapper {\n      display: flex;\n      padding-right: 45px;\n    }\n  }\n\n  &-header {\n    font-size: 12px;\n    font-weight: 600;\n    color: #737980;\n    height: 32px;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    width: 100%;\n\n    &-right {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      flex-grow: 1;\n    }\n  }\n\n  &-section-sub-title {\n    color: #737980;\n    font-size: 12px;\n    font-weight: 500;\n    margin-bottom: 0;\n    width: 100%;\n\n    &-timezone {\n      margin-top: 0;\n      font-style: italic;\n    }\n  }\n\n  &-title {\n    margin-top: auto;\n    margin-bottom: auto;\n    text-transform: capitalize;\n    width: 100px;\n  }\n\n  &-open-icon {\n    height: 15px;\n    margin-top: auto;\n    margin-bottom: auto;\n    padding-left: 5px;\n  }\n\n  &-preview {\n    cursor: pointer;\n    display: flex;\n    background-color: #f7f8f9;\n    border-top: 1px solid #e3e4e6;\n    border-bottom: 1px solid #e3e4e6;\n    justify-content: flex-start;\n    padding-left: 25px;\n    padding-top: 12px;\n    padding-bottom: 12px;\n    color: #333;\n\n    & > h3 {\n      font-weight: 600;\n      margin-top: auto;\n      margin-bottom: auto;\n    }\n  }\n\n  &-bottom-spacing {\n    margin-bottom: 5px;\n  }\n\n  &-day-windows {\n    width: 50%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
